var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section full-page bg-dark-gray wf-section"
  }, [_c('loading-page'), _c('div', {
    staticClass: "w-layout-grid main-grid full-page"
  }, [_c('div', {
    staticClass: "box-wrapper inner-padding-medium justify login-wrapper"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "form-wrapper left"
  }, [_c('div', {
    staticClass: "full-form w-form"
  }, [_c(_vm.activeForm, {
    tag: "component"
  }), _c('div', {
    staticClass: "loginBtnwrapper"
  }, [_c('button', {
    staticClass: "w-button border",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleFormSubmit.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.activeForm === 'LoginForm' ? 'Prihlásiť' : 'Registrovať') + " ")]), _c('button', {
    staticClass: "main-paragraph secondary-button",
    staticStyle: {
      "text-align": "left"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleFormChange.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.activeForm === 'LoginForm' ? 'Ak ešte nemáte u nás konto a dostali ste od nás registračný token, pokračujte do registrácie ' : 'Pre prihlásenie kliknite ') + " "), _c('span', {
    staticClass: "text-primary bold"
  }, [_vm._v("TU")])])])], 1)])])]), _vm._m(0)])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "overflow-wrapper signup image-wrapper"
  }, [_c('img', {
    staticClass: "full-image",
    attrs: {
      "src": require("../../images/login-image.jpg"),
      "loading": "lazy",
      "alt": ""
    }
  })]);

}]

export { render, staticRenderFns }